import React, { Component } from 'react';
import DiskussionenDetails from '../components/DiskussionenDetails'; 
import SidebarKalender from '../components/SidebarKalender'; 
import Flexbox from '../components/misc/Flexbox'; 
import SubmenuDiscussion from '../components/SubmenuDiscussion'; 

class DiskussionenDetailsContainer extends Component {
  
  componentWillMount(){
	document.body.scrollTop = document.documentElement.scrollTop = 0;
  }		
  componentDidMount(){	 
	setTimeout(function(){
		document.getElementById('menu-diskussionen').classList.add('active');
		document.getElementById('submenu-diskussionen').classList.add('active');
	},400);	
  }
  componentWillUnmount(){
	document.getElementById('menu-diskussionen').classList.remove('active');
	document.getElementById('submenu-diskussionen').classList.remove('active');
  }
  render() {
		   const {page,parent} = this.props.resolves;
		   return (
               <div>
					<SubmenuDiscussion {...parent} />
				   <div className="container-fluid lg-side-padding">
						<div className="row">
							<DiskussionenDetails {...page} /> 
							{
								(page.vermittlung_kategorie) ?
								<section className="col-md-4 sidebar">
									<div className="calendar-block sidebar-block">
										<Flexbox left={page.sidebar_left} right={page.sidebar_right} />
										
										<section className="events-calendar mini-calendar">
										{
											page.vermittlung_kategorie.map( (data,i)=>
												<SidebarKalender key={i} {...data} />
											)
										}	
										</section>                   
									</div>
								</section>
								: null
							}
						</div>
					</div>
				</div>
            )
       
  }
}
export default DiskussionenDetailsContainer;


// WEBPACK FOOTER //
// ./src/containers/DiskussionenDetailsContainer.js